import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';


import '../css/SystemIntegratorEdit.css';
import ErrorText from '../ErrorText';
import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';

// system integrator edit page  component
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '90%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const SiRating = [
  { label: 'A++' },
  { label: 'A' },
  { label: 'B+' },
];

const SiRelationStat = [
  { label: 'Hot' },
  { label: 'Warm' },
  { label: 'Dry' },
  { label: 'Cold' },
];


export default class SubscriptionPlanEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
      noOfParams: [],
    //   SiName: this.props.siCurrentData.si_name,
  

    PlanName: this.props.SUbCurrentData.plan_name,
    Fees: this.props.SUbCurrentData.fees,
    Currency: this.props.SUbCurrentData.currency,
    Feature1: this.props.SUbCurrentData.feature[0],
    Feature2: this.props.SUbCurrentData.feature[1],
    buldingId: this.props.SUbCurrentData.bulding_id,
      errorMessage: [],
      modalIsOpenSuccess: false,
      loader: false,
      disableSave: true,
      snackbarActive: false,
      snackbarMessage: ''

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);

  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }


  closeModalSuccess() {
    this.setState({
      modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpenSuccess: false
        },()=>{
          this.props.closeAllModal()
        })
      }, 500);

    })
  }
  afterOpenModal() {
  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false
        },()=>{
        //   this.props.closeAllModal()
        })
      }, 500);

    })
  }

//   onSelectChange = (operationMode, valueSelect) => {
//     if (operationMode === 'rating') {
//       this.setState({
//         SiRating: valueSelect.value,
//         errorMessage: [],
//         disableSave: false
//       })
//     }
//     if (operationMode === 'relationStat') {
//       this.setState({
//         SiRelationStat: valueSelect.value,
//         errorMessage: [],
//         disableSave: false
//       })
//     }
//     if (operationMode === 'siArea') {
//       this.setState({
//         SiArea: valueSelect.value,
//         errorMessage: [],
//         disableSave: false
//       })
//     }
//   }

  componentDidMount() {
    this.fecthAllSI();
   
  }

  fecthAllSI = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/plan/', {
      method: "GET",
      headers: headers,
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        let siData = data;
        this.setState({
          siData: siData.data,
          
        })
       
        console.log(this.state.siData)
      })
      .catch((err)=>{
        console.log(err)

      })
  }



  onEditFinal = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    let plan_name = this.state.PlanName;
    let fees = this.state.Fees;
    let currency = this.state.Currency;
    let feature = this.state.Feature1;
    let  project_buildin = this.state.buldingId;
    // let si_address = this.state.SiAddress;
    // let si_description = this.state.SiDescription;
    // let si_rating = this.state.SiRating
    // let si_relationstatus = this.state.SiRelationStat;
    // let si_gstin = this.state.SiGST;

    fetch(`/cloud/plan/${this.props.SUbCurrentData.id}`, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify({
        plan_name,

        fees,
        
        currency,
        
        feature,
        
        project_buildin,
      })
    })
    
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        let rawData = data;
        data=data.data
        let index = Object.keys(data)[0]
        console.log(index + ": " + data[Object.keys(data)[0]])
       let  errorLog = index + ": " + data[Object.keys(data)[0]]
       if(rawData.message!=='failure'){    
        this.setState({
          modalIsOpen: false,
          loader: false
        }, () => {
          this.setState({
            modalIsOpenSuccess: true,
          })
        })
      }else{
        this.setState({
          loader: false,
          snackbarActive: true,
          snackbarMessage: errorLog
        })        
      }
      })
      .catch((err)=>{
        console.log(err)
      })
  }

  handleChangeInputBox = (name, event) => {
    this.setState({
      [name]: event,
      disableSave: false,

    });
  };

  onEdit = () => {
    this.setState({
      showErrorMessage: true
    }, () => {
      this.fetchError((e) => {
        if (e === 'NoError') {
          this.setState({
            loader: true,
            disableSave: true
          }, () => this.onEditFinal())
        }
      })
    })
  }

  fetchError = (noError) => {
    var totalError = 0;

    if (ErrorText('notEmpty', this.state.PlanName) === 'No Error') {
      totalError = totalError - 1;
    }

    if (ErrorText('email', this.state.Fees) === 'No Error') {
      totalError = totalError - 1;
    }
    if (ErrorText('notEmpty', this.state.Currency) === 'No Error') {
      totalError = totalError - 1;
    }
    if (ErrorText('isMobile', this.state.Feature1) === 'No Error') {
      totalError = totalError - 1;
    }
    if (ErrorText('notEmpty', this.state.Feature2) === 'No Error') {
      totalError = totalError - 1;
    }
    if (ErrorText('notEmpty', this.state.buldingId) === 'No Error') {
      totalError = totalError - 1;
    }
    if (totalError === 0) {
      noError('NoError');
    }
  }




  render() {
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0"  style={{ color: '#888888', fontSize: '30px', }}>Edit Subscription Plan</h3>
          <div className="row">
            <div className="col-12  mx-0 px-0 disableEvent" style={{pointerEvents: 'none'}}>
              <InputBox
                inputText={this.state.PlanName}
                // error={ErrorText('notEmpty', this.state.SiName) !== 'No Error' && this.state.showErrorMessage ? true : false}
                // errorText={ErrorText('notEmpty', this.state.SiName) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the SI Name' : ''}
                placeholder="Plan Name"
                inputBoxName="PlanName"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={50}
                validate={true}
              />
            </div>
            <div className="col-12  mx-0 px-0 disableEvent " style={{pointerEvents: 'none'}}>
              <InputBox
                inputText={this.state.Fees}
                // error={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? true : false}
                // errorText={ErrorText('email', this.state.SiEmail) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid SI Email' : ''}
                placeholder="Fees"
                inputBoxName="Fees"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={255} />
            </div>
            <div className="col-12  mx-0 px-0">
              <InputBox
                inputText={this.state.Currency}
                // error={ErrorText('notEmpty', this.state.SiCompany) !== 'No Error' && this.state.showErrorMessage ? true : false}
                // errorText={ErrorText('notEmpty', this.state.SiCompany) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the SI Company' : ''}
                placeholder="Currency"
                inputBoxName="Currency"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={100}
                validate={true}
              />
            </div>
            <div className="col-12  mx-0 px-0">
              <InputBox
                inputText={this.state.Feature1}
                // error={ErrorText('isMobile', this.state.SiMobile) !== 'No Error' && this.state.showErrorMessage ? true : false}
                // errorText={ErrorText('isMobile', this.state.SiMobile) !== 'No Error' && this.state.showErrorMessage ? 'Please enter a valid SI Mobile of 10 digits' : ''}
                // isNumber={true}
                placeholder="Feature 1"
                inputBoxName="Feature1"
                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                textLength={10}
                validate={true}
              />
            </div>
           
          </div>
          <div className="float-right" style={{marginTop: '70px', marginRight: '-15px'}}>
            <div className="btn btn-new-grey" onClick={this.closeModal} style={{marginRight: '15px'}} >Cancel</div>
            <div className="btn btn-new-green" onClick={() => {
              if (!this.state.disableSave) {
                this.onEdit()
              }
            }
            }
              style={{
                cursor: this.state.disableSave ? 'not-allowed' : '',
              }}
            >Save Changes</div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalSuccess}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Plan edited successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn btn-new-grey"
              onClick={this.closeModalSuccess}>
              Close
                            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
